<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">基础信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="providentFundTempData" label-width="200px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="配置名称:" required>
              <el-input v-model="providentFundTempData.name" placeholder="配置名称" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="公积金地区:" required>
              <el-select v-model="providentFundTempData.area_id" placeholder="公积金地区" clearable>
                <el-option v-for="item in socialSecurityAreaList" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号:" required>
              <el-input-number :min="0" v-model="providentFundTempData.sort_no" placeholder="序号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="缴费基数:" required>
              <el-input-number :min="0" v-model="providentFundTempData.base_pay" step="1000" placeholder="缴费基数"
                               clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">公积金比例:</label>
    <el-card style="margin: 5px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司(%):" label-width="200px" required>
            <el-input v-model="providentFundTempData.company_pay_scale" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="缴费比例" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="个人(%):" label-width="200px" required>
            <el-input :min="0" v-model="providentFundTempData.employee_pay_scale" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')"  placeholder="缴费比例"  clearable/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">地区公积金最低缴费设置:</label>
    <el-card style="margin: 5px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="地区最低缴费基数:"  label-width="200px" required>
            <el-input-number :min="0" v-model="providentFundTempData.minimum_base_pay" step="1000" placeholder="缴费基数"  clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区最低缴费比例-公司(%):"  label-width="200px" required>
            <el-input :min="0" v-model="providentFundTempData.minimum_pay_scale_company" oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')"  placeholder="缴费比例"  clearable/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>
    <div style="text-align: center;margin-bottom: 20px;margin-top: 10px">
      <el-button style="width: 100px" type="primary" :loading="loading" @click="saveProvidentTemp">保存</el-button>
    </div>
  </el-scrollbar>
</template>

<script>

export default {
  name: "ProvidentFundTemplate",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        value: 'type',
        label: 'name'
      },
      loading: false,
      providentFundTempData: {},
      socialSecurityAreaList: [],
    }
  },
  methods: {
    async loadSecurityTempInfo() {
      let params = {id: this.parentData.id}
      let dbTemp = await this.$http('salaryInfoSetService.getProvidentById', params);
      if (dbTemp) {
        this.providentFundTempData = dbTemp;
      }
    },
    // 获取社保缴纳地
    async getSocialSecurityArea() {
      let params = {modelId: "salary_social_security_area"}
      this.socialSecurityAreaList = await this.$http('employeeHRService.getAll', params);
    },
    saveProvidentTemp() {
      if (!this.providentFundTempData.name) {
        return this.$message.error("配置名称不能为空")
      }
      if (!this.providentFundTempData.area_id) {
        return this.$message.error("公积金地区不能为空")
      }
      if (!this.providentFundTempData.base_pay) {
        return this.$message.error("缴费基数不能为空")
      }
      if (!this.providentFundTempData.minimum_base_pay) {
        return this.$message.error("地区最低缴费基数不能为空")
      }
      if (!this.providentFundTempData.company_pay_scale) {
        return this.$message.error("公司(%)不能为空")
      }
      if (!this.providentFundTempData.employee_pay_scale) {
        return this.$message.error("个人(%)不能为空")
      }

      let companyPayScale = Number(this.providentFundTempData.company_pay_scale);
      if (Number.isNaN(companyPayScale) || companyPayScale >= 100 || companyPayScale <= 0) {
        return this.$message.error("公积金比例-公司的范围需在0-100之间")
      }
      let employeePayScale = Number(this.providentFundTempData.employee_pay_scale);
      if (Number.isNaN(employeePayScale) || employeePayScale >= 100 || employeePayScale <= 0) {
        return this.$message.error("公积金比例-个人的范围需在0-100之间")
      }
      let minimumPayScaleCompany = Number(this.providentFundTempData.minimum_pay_scale_company);
      if (Number.isNaN(minimumPayScaleCompany) || minimumPayScaleCompany >= 100 || minimumPayScaleCompany <= 0) {
        return this.$message.error("地区最低缴费比例-公司的范围需在0-100之间")
      }
      this.loading = true;
      this.$http('salaryInfoSetService.saveProvidentFundTemp', this.providentFundTempData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);
        this.loading = false;
      })
    },
  },
  created() {
    this.getSocialSecurityArea();
    this.loadSecurityTempInfo();
  },

}
</script>

<style scoped lang="less">

</style>